import { useTranslation } from 'react-i18next'

import { fieldProgramCreditOpportunityColumn } from './fieldProgramCreditOpportunityColumn'
import { fieldProgramDollarOpportunityColumn } from './fieldProgramDollarOpportunityColumn'
import { fieldProgramEarningsColumn } from './fieldProgramEarningsColumn'
import { fieldProgramOpportunityColumn } from './fieldProgramOpportunityColumn'
import { fieldProgramProgressColumn } from './fieldProgramProgressColumn'
import {
  FieldProgramRecommendationColumnProps,
  fieldProgramRecommendationColumn,
} from './fieldProgramRecommendationColumn'
export * from './fieldProgramEarningsColumn'
export * from './fieldProgramProgressColumn'
export * from './fieldProgramsColumn'
export * from './useFieldProgramTraitReasonsColumn'
export * from './fieldTaskEligibilityColumn'

export const useProgramFieldColumns = (programId: string) => {
  const { t } = useTranslation('@cibo/programs/components/ProgramFieldColumns')

  return {
    fieldProgramCreditOpportunityColumn: fieldProgramCreditOpportunityColumn({ programId, t }),
    fieldProgramDollarOpportunityColumn: fieldProgramDollarOpportunityColumn({ programId, t }),
    fieldProgramEarningsColumn: fieldProgramEarningsColumn({ programId, t }),
    fieldProgramOpportunityColumn: fieldProgramOpportunityColumn({ programId, t }),
    fieldProgramProgressColumn: fieldProgramProgressColumn({ programId, t }),
    fieldProgramRecommendationColumn: (
      props: Pick<FieldProgramRecommendationColumnProps, 'benchmark' | 'DialogActions'>
    ) =>
      fieldProgramRecommendationColumn({
        ...props,
        programId,
        t,
      }),
  }
}
